import React from "react";
import Header from "./Header";
import './App.css'
import Table from "./Table";

function App() {

  return (
    <div className="body"> 
      <Header/>
      <Table/>
    </div>
  );
}

export default App;
